import type { SiteStatus } from '@safetyhub/shared';

/**
 * 현장 생애주기 표시 — 활성/비활성 boolean이 2026-08-03에 4값 enum으로 통합됐다
 * (결정 기록 `2026-08-03-site-status-axes`). 목록과 상세 모달이 같은 말을 하도록
 * 라벨·색을 한 곳에 둔다.
 */
export type { SiteStatus };

export const SITE_STATUS_LABELS: Record<SiteStatus, string> = {
  ACTIVE: '운영중',
  PAUSED: '일시중지',
  CLOSED: '종료',
  TRANSFER_PENDING: '이관중',
};

/**
 * 운영 중만 초록. 멈춘 상태는 주황(재개 가능)과 회색(끝남)으로 갈라 둔다 —
 * 둘을 한 색으로 접으면 boolean 시절과 같은 정보 손실이 된다.
 */
export const SITE_STATUS_BADGE_CLASS: Record<SiteStatus, string> = {
  ACTIVE: 'bg-green-100 text-green-700',
  PAUSED: 'bg-amber-100 text-amber-700',
  CLOSED: 'bg-gray-100 text-gray-600',
  TRANSFER_PENDING: 'bg-orange-100 text-orange-700',
};

/**
 * 수정 폼에서 고를 수 있는 상태 — `TRANSFER_PENDING`은 이관 플로우가 소유하는 상태라
 * 직접 설정할 수 없다(서버 `updateSite`도 같은 3값만 받는다).
 */
export type SiteEditableStatus = Exclude<SiteStatus, 'TRANSFER_PENDING'>;

export const SITE_EDITABLE_STATUS_OPTIONS: { value: SiteEditableStatus; label: string }[] = [
  { value: 'ACTIVE', label: SITE_STATUS_LABELS.ACTIVE },
  { value: 'PAUSED', label: SITE_STATUS_LABELS.PAUSED },
  { value: 'CLOSED', label: SITE_STATUS_LABELS.CLOSED },
];

/** 이관중 현장은 폼이 status를 대신 써 보내면 안 된다(이관 플로우가 소유 중). */
export function isSiteStatusEditable(status: SiteStatus): status is SiteEditableStatus {
  return status !== 'TRANSFER_PENDING';
}
